var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1812 0.137939C16.3479 0.137939 15.5979 0.221273 14.8896 0.471273C15.7646 1.17961 16.5146 2.05461 17.1396 3.01294H17.1812C20.0979 3.01294 22.4729 5.38794 22.4729 8.30461C22.4729 11.2213 20.0979 13.5963 17.1812 13.5963C16.4729 13.5963 15.7229 13.4713 15.0979 13.1796C15.4729 12.6379 15.8062 12.0546 16.0562 11.5129C16.1396 11.2629 16.2646 11.0963 16.3062 10.8463C16.5562 10.0963 16.6812 9.22127 16.6812 8.34627C16.6812 3.84627 13.0146 0.179606 8.51457 0.179606C4.01457 0.179606 0.3479 3.80461 0.3479 8.30461C0.3479 12.8046 4.01457 16.4713 8.51457 16.4713C9.3479 16.4713 10.0979 16.3879 10.8062 16.1379C9.93123 15.4296 9.18123 14.5546 8.55623 13.5963H8.51457C5.5979 13.5963 3.2229 11.2213 3.2229 8.30461C3.2229 5.38794 5.5979 3.01294 8.51457 3.01294C9.2229 3.01294 9.9729 3.13794 10.6396 3.42961C9.63957 4.76294 9.01457 6.47127 9.01457 8.30461C9.01457 12.8046 12.6812 16.4713 17.1812 16.4713C21.6812 16.4713 25.3479 12.8046 25.3479 8.30461C25.3479 3.80461 21.6812 0.137939 17.1812 0.137939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCms);
export default __webpack_public_path__ + "static/media/CMS.a4e67d39f7f200d6b9571aea40ee92b7.svg";
export { ForwardRef as ReactComponent };